import { render } from "./App.vue?vue&type=template&id=0f7703a9"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0f7703a9&lang=scss"

import exportComponent from "/Users/lml/Code/threeman-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__